import injectCampaigns from "./injectCampaigns"
import executeScripts from "./injectScripts"
import instrumentTiming from "./sendTiming"
import { EventResponseMessage } from "@/types"
import bus from "../../bus"
import visit from "@/core/visit"
import { domReady } from "@/core/domReady"

function emitPrerender(response: EventResponseMessage) {
  bus.emit("prerender", {
    customerId: visit.getCustomerId(),
    affinityScores: response.af,
    geoLocation: response.gl,
    eventDate: response.ed,
    pageViews: response.pv,
    segments: response.se
  })
}

function emitDebugdata(response: EventResponseMessage) {
  if (response.debug) {
    bus.emit("debugdata", response.debug)
  }
}

function emitServerError(response: EventResponseMessage) {
  if (response.errors && response.errors.length) {
    bus.emit("servererror", response.errors)
  }
}

export function injectResponseData(response: EventResponseMessage, targets: Record<string, HTMLElement>) {
  domReady(() => injectCampaigns(response, targets))
}

export default (responseData: EventResponseMessage, targets: Record<string, HTMLElement>, render: boolean) => {
  const responseReady = new Date()
  emitDebugdata(responseData)
  emitServerError(responseData)
  emitPrerender(responseData)
  if (render) {
    injectResponseData(responseData, targets)
  }
  void executeScripts(responseData)
  instrumentTiming(responseData, responseReady)
}
